// extracted by mini-css-extract-plugin
export default {"action":"Action-module__action__hdLN0","content":"Action-module__content__UGSlz","lock":"Action-module__lock__YPvj0"};